var state={
    search:'',
}
var getter={
    getSearch(){
        return state.search;
    },
}

var mutations={
    setSearch(state,search){
        state.search = search;
    },
   
}

export default{
    state,
    getter,
    mutations,
}
